export default "__VITE_ASSET__B4IkIGI7__"